import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { assignPointThunk } from "./thunk";

interface AssignmentState {
    loading: boolean;
    error: string | null;
    currentEstablishment: string | null;
    currentPoint: string | null;
}

const initialState: AssignmentState = {
    loading: false,
    error: null,
    currentEstablishment: null,
    currentPoint: null,
};

const assignmentsSlice = createSlice({
    name: "assignment",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        setCurrentAssignments: (state, action: PayloadAction<{ establishmentId?: string; pointId?: string }>) => {
            state.currentEstablishment = action.payload.establishmentId || null;
            state.currentPoint = action.payload.pointId || null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Assign point
            .addCase(assignPointThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(assignPointThunk.fulfilled, (state, action) => {
                state.loading = false;
                if (action.meta.arg) {
                    state.currentEstablishment = action.meta.arg.establishmentId;
                    state.currentPoint = action.meta.arg.emissionPointId;
                }
            })
            .addCase(assignPointThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError, setCurrentAssignments } = assignmentsSlice.actions;
export default assignmentsSlice.reducer;
